<template>
  <div class="sub-footer">
    <div class="grid-container fluid">
      <div class="grid-x grid-margin-x align-middle">
        <template v-if="$route.path == '/about'">
          <div class="cell small-6">
            <div
              class="sub-footer__action sub-footer__action--left"
              data-aos="fade-right"
              data-aos-duration="400"
              data-aos-offset="0"
            >
              <router-link
                to="/"
                class="button large"
              >
                Annual Report Home
              </router-link>
            </div>
          </div>
          <div class="cell small-6 text-right">
            <div
              class="sub-footer__action sub-footer__action--right"
              data-aos="fade-left"
              data-aos-duration="400"
              data-aos-offset="0"
            >
              <a
                href="https://www.svmic.com"
                class="button large"
              >
                Visit svmic.com
              </a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="cell text-center">
            <div
              class="sub-footer__action sub-footer__action--center"
              data-aos="fade-up"
              data-aos-duration="400"
              data-aos-offset="0"
            >
              <router-link
                :to="nextRoute"
                class="button large"
              >
                Next Section
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSubFooter',
  props: {
    nextRoute: String
  }
};
</script>
